import { Button, ButtonProps } from '@material-ui/core';
import { ColoredCommonProps, withColoredStyles } from './common';

type ColoredButton = {
  <C extends React.ElementType>(
    props: ButtonProps<C, { component?: C }> & ColoredCommonProps
  ): JSX.Element;
};

export const ColoredButton = withColoredStyles(({ colored, coloredHover, ...props }: any) => (
  <Button {...props} />
)) as ColoredButton;
